var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5,2.1h-0.3V1c0-0.5-0.4-1-1-1s-1,0.4-1,1v1.2H6.7V1c0-0.5-0.4-1-1-1s-1,0.4-1,1v1.2H4.5c-1.6,0-3,1.3-3,3V14c0,1.6,1.3,3,3,3h9c1.6,0,3-1.3,3-3V5.1C16.5,3.5,15.2,2.1,13.5,2.1z M4.5,4.1h0.3v1.2c0,0.5,0.4,1,1,1s1-0.4,1-1V4.1h4.5v1.2c0,0.5,0.4,1,1,1s1-0.4,1-1V4.1h0.2c0.5,0,1,0.4,1,1v2.4h-11V5.1C3.5,4.6,3.9,4.1,4.5,4.1z M13.5,15h-9c-0.5,0-1-0.4-1-1V9.5h11V14C14.5,14.6,14.1,15,13.5,15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar18);
export default __webpack_public_path__ + "static/media/calendar-18.a30c2653713b5a465b73dd62b9ae5c0b.svg";
export { ForwardRef as ReactComponent };